import "./Navbar.css";

import { useEffect, useState } from "react";

import {
  onAuthStateChanged,
  signOut,
} from "firebase/auth";

import {
  doc,
  getDoc,
} from "firebase/firestore";

import Badge from "react-bootstrap/Badge";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

import { LinkContainer } from "react-router-bootstrap";
import { useNavigate } from "react-router-dom";

import {
  auth,
  db,
} from "@/Firebase";

import logo from "@/assets/general/logo77.webp";
import { navitems } from "./Navitem";

function MyNavbar() {
  const [user, setUser] = useState(null);
  const [userName, setUserName] = useState("");
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  // Récupérer le nom de l'utilisateur depuis Firestore
  const fetchUserName = async (uid) => {
    try {
      const userDoc = doc(db, "users", uid);
      const userSnap = await getDoc(userDoc);

      if (userSnap.exists()) {
        const data = userSnap.data();

        setUserName(
          data.nom ||
          data.prenom ||
          ""
        );
      } else {
        setUserName("");
        console.log(
          "Aucun document Firestore trouvé pour cet utilisateur"
        );
      }
    } catch (error) {
      console.error(
        "Erreur lors de la récupération du nom d'utilisateur :",
        error
      );
    }
  };

  // Vérifier l'état de connexion Firebase
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(
      auth,
      async (firebaseUser) => {
        try {
          if (firebaseUser) {
            setUser(firebaseUser);

            await fetchUserName(
              firebaseUser.uid
            );
          } else {
            setUser(null);
            setUserName("");
          }
        } catch (error) {
          console.error(
            "Erreur authentification :",
            error
          );
        } finally {
          setLoading(false);
        }
      }
    );

    return () => unsubscribe();
  }, []);

  // Créer un compte
  const handleCreateAccount = () => {
    navigate("/signup");
  };

  // Se connecter
  const handleLoginRedirect = () => {
    navigate("/login");
  };

  // Déconnexion
  const handleSignOut = async () => {
    try {
      await signOut(auth);

      setUser(null);
      setUserName("");

      navigate("/");
    } catch (error) {
      console.error(
        "Erreur lors de la déconnexion :",
        error
      );
    }
  };

  // Accéder au profil
  const handleRedirect = () => {
    navigate("/edit");
  };

  return (
    <Navbar
      expand="lg"
      collapseOnSelect
      className="custom-navbar"
    >
      <Container
        fluid
        className="custom-navbar-container"
      >
        {/* Logo */}
        <LinkContainer to="/">
          <Navbar.Brand className="custom-navbar-brand">
            <img
              src={logo}
              alt="BKBO"
              className="custom-navbar-logo"
            />
          </Navbar.Brand>
        </LinkContainer>

        {/* Bouton menu mobile */}
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          className="custom-navbar-toggle"
        />

        {/* Menu */}
        <Navbar.Collapse
          id="basic-navbar-nav"
          className="custom-navbar-collapse"
        >
          {/* Navigation */}
          <Nav className="custom-navbar-nav">
            {navitems.map((item) => (
              <LinkContainer
                to={item.path}
                key={item.id}
              >
                <Nav.Link
                  className={`custom-navbar-link ${
                    item.cName || ""
                  }`}
                >
                  {item.title}
                </Nav.Link>
              </LinkContainer>
            ))}
          </Nav>

          {/* Partie utilisateur */}
          <div className="navbar-user-actions">
            {loading ? (
              <div
                className="spinner-border text-success"
                role="status"
              >
                <span className="visually-hidden">
                  Chargement...
                </span>
              </div>
            ) : !user ? (
              <>
                {/* Connexion */}
                <Button
                  variant="outline-success"
                  onClick={handleLoginRedirect}
                  className="navbar-login-btn"
                >
                  Se connecter
                </Button>

                {/* Créer un compte */}
                <Button
                  variant="success"
                  onClick={handleCreateAccount}
                  className="navbar-signup-btn"
                >
                  Créer un compte
                </Button>
              </>
            ) : (
              <div className="navbar-connected-user">
                {/* Nom utilisateur */}
                <Badge
                  bg="success"
                  className="navbar-user-badge"
                  onClick={handleRedirect}
                  title="Mon profil"
                >
                  {userName ||
                    user.displayName ||
                    user.email}
                </Badge>

                {/* Déconnexion */}
                <Button
                  variant="success"
                  size="sm"
                  onClick={handleSignOut}
                  className="navbar-logout-btn"
                >
                  Déconnexion
                </Button>
              </div>
            )}
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default MyNavbar;